import { RocketLaunch, X } from '@phosphor-icons/react';
import { Banner, Button, Text, Flex } from '@chatsdet/ui';
type ExplorationBannerProps = {
  onDismiss: () => void;
};

export function ExplorationBanner({ onDismiss }: ExplorationBannerProps) {
  return (
    <div className="absolute top-16 left-1/2 -translate-x-1/2 z-30">
      <Banner variant="info" className="shadow-lg whitespace-nowrap">
        <Flex align="center" gap="sm">
          <RocketLaunch size={18} className="text-blue-600 dark:text-blue-400 shrink-0" />
          <Text size="sm" weight="medium">
            The agent is doing some exploration to build out the full test — grab a coffee, we'll
            keep working in the background!
          </Text>
        </Flex>
        <Button variant="icon" size="sm" iconOnly tooltip="Dismiss" onPress={onDismiss}>
          <X size={14} />
        </Button>
      </Banner>
    </div>
  );
}
